<template>
    <div class="registerProvisionalWrapper">
        <div class="titleWrapper">
            <p class="subtitleItem px-5">Register</p>
            <h2 class="titleItem">新規会員登録</h2> 
        </div>

        <div class="card">
            <div class="card-body">
                <user-signup-step state="send_email" class="mt-3"/>
                
                <form @submit.stop.prevent="submit">
                    <div class="mail-form">
                        <div class="col">
                            <label
                                for="email"
                                class="col-form-label mail-label">
                                メールアドレスで会員登録
                            </label>
                            <p class="p-text">初めてご利用の場合は会員登録のお手続き（無料）が開始されます</p>
                            <input
                                v-model="email"
                                type="email"
                                name="email"
                                id="email"
                                class="form-control mb-3"
                                :class="{ 'is-invalid' : errors.email || errors.message }"
                                placeholder="メールアドレス"
                                required>
                            <button
                                type="submit"
                                class="btn btn-yokumiru-user loginButton mb-4"
                                style="line-height:0"
                                :disabled="inProgress">
                                {{ inProgress ? '処理中です' : 'メールアドレスを送信する' }}
                            </button>
                            <div v-if="errors.email" class="invalid-feedback d-block">
                                {{ errors.email[0] }}
                            </div>
                            <div v-else-if="errors.message" class="invalid-feedback d-block">
                                {{ errors.message[0] }}
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="errors.email && errors.email[0] === 'メールアドレスは既に登録されています。'"
                        class="form-row">
                        <div class="col">
                            <div class="registerProvisionalEmailDuplicated small mt-1">
                                パスワードをお忘れの場合は、<a href="/password/reset">こちら</a>からパスワードの再発行ができます。
                            </div>
                        </div>
                    </div>

                    <hr class="divider mt-4 mb-4">

                    <div class="loginButtonWrapper">
                        <label
                            for=""
                            class="col-form-label mail-label">
                            その他の方法で会員登録
                        </label>
                        <p class="p-text">初めてご利用の場合は会員登録のお手続き（無料）が開始されます</p>
                        <div class="sns-btn">
                            <a
                                :href="`/social/oauth/redirect/line${appQuery}`"
                                class="loginButton loginButtonLine d-flex align-items-center">
                                <div class="loginButtonImage d-flex align-items-center">
                                    <img src="/images/common/social_login_line.png">
                                </div>
                                <div class="loginButtonText whitespace-nowrap overflow-hidden text-ellipsis min-w-0">
                                    LINEアカウントで登録
                                </div>
                            </a>
                            <a
                                :href="`/social/oauth/redirect/apple${appQuery}`"
                                class="loginButton loginButtonApple d-flex align-items-center">
                                <div class="loginButtonImage d-flex align-items-center">
                                    <img src="/images/common/social_login_apple.svg">
                                </div>
                                <div class="loginButtonText">
                                    Appleでサインアップ
                                </div>
                            </a>
                        </div>
                    </div>
                    <hr class="divider">
                    <div class="text-center">
                        <a
                            class="loginFormTextLink"
                            :href="`/login${appQueryAsLogin}`">
                            ログインページに戻る
                        </a>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import YokumiruHelper from '../../YokumiruHelper'
import constants from '../../constants'

export default {
    props: {
        appQuery: {
            type: String,
            default: '',
        },
        planKey: {
            type: String,
            default: '',
        },
        formrunUid: {
            type: String,
            required: true,
        },
        couponCode: {
            type: String,
            default: '',
        },
        deviceId: {
            type: String,
            default: '',
        },
        authToken: {
            type: String,
            default: '',
        },
        tags: {
            type: String,
            default: '',
        },
    },

    data: function() {
        return {
            helper: YokumiruHelper,
            email: null,
            inProgress: false,
            errors: {},
            active: 'send_email',
        }
    },

    computed: {
        appQueryAsLogin: function () {
            return this.appQuery.replace('is_login=0', 'is_login=1')
        },
    },

    methods: {
        /**
         * 新規会員登録
         */
        submit: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const params = {
                email: this.email,
                utm_content: 'システム内新規会員登録ページ',
                source: '未設定',
                formrun_uid: this.formrunUid,
            }

            if (this.planKey) {
                params['plan_key'] = this.planKey
            }
            if (this.couponCode) {
                params['coupon_code'] = this.couponCode
            }
            if (this.deviceId && this.authToken) {
                params['device_id'] = this.deviceId
                params['auth_token'] = this.authToken
            }
            if (this.tags) {
                params['tags'] = this.tags
            }

            await axios.post(constants.user.register_provisional.endpoint.base, params)
                .then(() => {
                    let query = ''
                    query += `&mailAddress=${this.email}`
                    query += this.planKey ? `&plan_key=${this.planKey}` : ''
                    query += this.tags ? `&tags=${this.tags}` : ''
                    query += this.deviceId && this.authToken ? `&device_id=${this.deviceId}&auth_token=${this.authToken}` : ''
                    window.location.href = `/register/provisional/complete${query.replace(/^&(.+)$/u, '?$1')}`
                })
                .catch(({response}) => {
                    if (response &&
                        response.hasOwnProperty('data') &&
                        response.data.hasOwnProperty('errors')) {
                        if (response.data.errors.hasOwnProperty('message')) {
                            bus.$emit('alert-danger', response.data.errors.message[0])
                            this.errors = response.data.errors
                        }
                        else {
                            bus.$emit('alert-danger')
                            this.errors = response.data.errors
                        }
                    }
                    else {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    }
                    // 登録が正常完了した場合のリダイレクト中にボタンを再押下させないために catch 内でのみ解除
                    this.inProgress = false
                })
        },
    },
}
</script>

<style lang="scss" scoped>
.titleWrapper {
    margin-bottom: 16px;
    text-align: center;
    .subtitleItem {
        margin-bottom: 5px;
        background-color: #F77795;
        color: white;
        border-radius: 10px;
        display: inline-block;
    }
    .titleItem {
        color: #2A2E31;
        font-size: 23px;
        font-weight: bold;
    }
}

.card {
    box-shadow: 0px 4px 12px 0px #00000026;
    border-radius: 0;
    border: none;
}

.mail-form{
    margin: 30px auto 0;
    width: 63%;
    //snsの文字が崩れるため821pxでメディアクエリをしています
    @media screen and(max-width:640px) {
        width: 100%;
        margin: 0;
        
    }

}

.mail-label{
    border-left: 3px solid #F77795;
    padding: 7px 10px;
    font-size: 17px;
    margin: 10px 0 5px;
}

.p-text{
    color: #b2b2b2;
}

.registerProvisionalWrapper {
    max-width: 950px;
    margin: 0 auto 100px auto;
    padding: 0 30px;

    @media screen and (max-width:640px) {
        padding: 0 15px;
    }

    .registerProvisionalEmailDuplicated {
        background: #ffe69a8f;
        padding: 8px 10px;
        border-radius: 4px;
        width: 60%;
        margin: 0 auto;

        a {
            text-decoration: underline;
        }
    }
}

.divider {
    width: 60%;
    margin: 0 auto;
    @media screen and(max-width:640px) {
        width: 100%;
        margin: 0 15px;
    }
}

.dividerOr {
    position: relative;
}

.dividerOr::after {
    content: 'そのほかの方法で会員登録';
    position: absolute;
    width: 180px;
    height: 20px;
    left: 50%;
    top: 0;
    color: #b2b2b2;
    font-size: 13px;
    text-align: center;
    background: #fff;
    transform: translate3d(-50%,-50%,0);
}

.loginFormLabel {
    color: #4d4a4a;
    font-size: 14px;
    margin-bottom: 3px;
}

.loginFormTextLink {
    display: inline-block;
    text-decoration: none;
    font-size: 14px;
    padding: 8px 16px;
    border-radius: 5px;
    color: white;
    background-color: #b2b2b2;
    margin: 24px 0;
    
}

.loginFormTextLink:hover {
    text-decoration: none;
}

.loginFormTextLinkSmall {
    font-size: 13px;
}

/**
 * loginButton
 */
.loginButtonWrapper {
    margin: 30px auto 0;
    padding: 0 15px;
    width: 63%;
    @media screen and(max-width:640px) {
        width: 100%;
        margin: 0;
        
    }
}

.loginButton {
    display: block;
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-decoration: none;
    border-radius: 4px;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out
}

.loginButton:hover {
    text-decoration: none;
}

.loginButtonImage {
    margin-left: 8px;
}

.loginButtonImage::after {
    content: '';
    display: inline-block;
    width: 1px;
    height: 30px;
    margin-left: 8px;
    background: rgba(0, 0, 0, 0.08);
}

.loginButtonImage img {
    width: 34px;
}

.loginButtonText {
    margin: 0 auto;
    color: #fff;
    font-size: 14px;
}

.sns-btn {
    display: flex;
    gap: 16px;
    margin-bottom: 32px;
    @media screen and (max-width:730px) {
        display: block;
    }
}

/**
 * loginButton - LINE
 */
.loginButtonLine {
    background: #03C755;
    @media screen and (max-width:730px) {
        margin-bottom: 16px;
    }
}

.loginButtonLine:hover {
    background: #0BB34C;
}

.loginButtonLine:hover .loginButtonImage::after {
    background: rgba(0, 0, 0, 0.1);
}

/**
 * loginButton - Apple
 */
.loginButtonApple {
    background: #000;
}

.loginButtonApple:hover {
    background: #313131;
}

.loginButtonApple .loginButtonImage {
    padding-left: 7px;
}

.loginButtonApple .loginButtonImage img {
    position: relative;
    top: -1px;
    width: 20px;
}

.loginButtonApple .loginButtonImage::after {
    margin-left: 14px;
    background: rgba(255, 255, 255, 0.3);
}
</style>
